import React, { AriaRole } from "react";
import { useRouter } from "next/router";
import { LinkProps } from "next/link";
import { resolveHref } from "next/dist/client/resolve-href";

type Props = LinkProps & {
  className?: string;
  role?: AriaRole;
  children: React.ReactNode;
};

export function LinkWithoutPrefetch(props: Props) {
  const router = useRouter();

  const { children, href, onClick, shallow, scroll, ...anchorProps } = props;
  const url = resolveHref(router, href);

  async function handleClick(event: React.MouseEvent<HTMLAnchorElement>) {
    event.preventDefault();
    onClick?.(event);
    await router.push(href, undefined, { shallow, scroll });
  }

  return (
    <a {...anchorProps} href={url} onClick={handleClick}>
      {children}
    </a>
  );
}
